module.exports = __webpack_public_path__ + "static/img/ios@2x.6308f339.png";